import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import ReactStars from 'react-stars'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IoIosClose } from 'react-icons/io';
import axios from 'axios';
import * as vars from '../../constants/constants';
import { FormattedMessage } from 'react-intl';
import {config} from '../../constants/domainConfig';

class Feedback extends Component {

    constructor(props){
        super(props)
        this.state={
            comment:'',
            overall_rating:0.0,
            content_rating:0.0,
            etn_rating:0.0,
            reliability_rating:0.0,
            success:false
        }
        this.ratingChanged=this.ratingChanged.bind(this);
        this.handleComment=this.handleComment.bind(this);
        this.handleAddFeedbackData=this.handleAddFeedbackData.bind(this);
        this.feedbackModalToggle=this.feedbackModalToggle.bind(this);
    }
    ratingChanged(newRating,rated){
        if(rated==="overall_rating"){
            this.setState({
                overall_rating:newRating
            })
        }else if(rated==="content_rating"){
            this.setState({
                content_rating:newRating
            })
        }else if(rated==="etn_rating"){
            this.setState({
                etn_rating:newRating
            })
        }else if(rated==="reliability_rating"){
            this.setState({
                reliability_rating:newRating
            })
        }
      }
      handleComment(e){
        this.setState({
            comment:e.target.value
        })
      }
      componentDidMount(){
        axios.get(vars.BASE_API_URL+"/getfeedback")
        .then((response) => {
            const data=response.data.data[0];
            this.setState({
                overall_rating:data.overall_rating,
                content_rating:data.content_rating,
                etn_rating:data.etn_rating,
                reliability_rating:data.reliability_rating,
                comment:data.comment
            })
        })
        .catch((error) => {
          console.log(error);
        });
      }
      handleAddFeedbackData(){
          const {overall_rating,content_rating,etn_rating,reliability_rating,comment}=this.state;
          const data={
            overall_rating,
            content_rating,
            etn_rating,
            reliability_rating,
            comment
          }
          axios.post(vars.BASE_API_URL+"/addfeedback", data)
          .then((response) => {
              const data=response.data.data;
              this.setState({
                  overall_rating:data.overall_rating,
                  content_rating:data.content_rating,
                  etn_rating:data.etn_rating,
                  reliability_rating:data.reliability_rating,
                  comment:data.comment,
                  success:true
              })
          })
          .catch((error) => {
            console.log(error);
          });
      }
      feedbackModalToggle(){
          this.setState({
              success:false
          })
          this.props.feedbackModalToggle();
      }
    render() {
        const {feedbackModal,feedbackModalToggle}=this.props;
        const {overall_rating,content_rating,etn_rating,reliability_rating,comment,success}=this.state;
        let commentPlaceholder;
        if (config.subDomain == 'be' || config.subDomain == 'nl'){
            commentPlaceholder='Voer uw opmerkingen of suggesties in.';
        }else if(config.subDomain == 'id') {
            commentPlaceholder="Silakan masukkan komentar Anda dari saran";
        }else if(config.subDomain == 'it') {
            commentPlaceholder="Inserisci i tuoi commenti e suggerimenti";
        }else if(config.subDomain == 'se') {
            commentPlaceholder="Ange dina kommentarer till förslag";
        }else if(config.subDomain == 'no') {
            commentPlaceholder="Skriv inn kommentar med forslag";
        }else if(config.subDomain == 'sn') {
            commentPlaceholder="Veuillez entrer vos commentaires de suggestions";
        }else if(config.subDomain == 'ee') {
            commentPlaceholder="Sisestage oma kommentaarid või ettepanekud.";
        }
        else if(config.subDomain == 'tr'){
            commentPlaceholder='Lütfen yorumlarınızı veya önerilerinizi girin.'
        }
        else if(config.lang === 'pt'){
            commentPlaceholder = 'Por favor, digite seu comentário de sugestão';
        }
        else{
            commentPlaceholder="Please enter your comments or suggestions.";
        }
        const feedbackClass = (config.lang == 'ar') ? "feedbackModal ar" : "feedbackModal"
        return (
            <Modal isOpen={feedbackModal} toggle={this.feedbackModalToggle} className={feedbackClass}>
                <div className="feedback-modal-header" >
                    <div className="feedback-modal-header-title">
                        <h3><b>
                            <FormattedMessage id="feedback"
                                defaultMessage="FEEDBACK"
                            />
                        </b></h3>
                    </div>
                    <IoIosClose onClick={this.feedbackModalToggle} size={25} />
                </div>
                <div className="feedback-modal-body">
                    {success?
                    <div className="feedback-success">
                        <h4><b>
                                <FormattedMessage id="feedbackWas"
                                    defaultMessage="Feedback was sent!"
                                />
                        </b></h4>
                    </div>
                    :
                    <div className="feedback-modal-body">
                    <h5 style={{ color: "#2196F3", textAlign: 'center', paddingBottom: '20px' }}>
                                <FormattedMessage id="weWould"
                                    defaultMessage="We would be very grateful if you could spare a few minutes to help us improve our website by completing this short survey- your feedback is very much appreciated."
                                />
                    </h5>
                    <div className={config.lang==='ar' ? 'feedback-star-rating-container-ar' :'feedback-star-rating-container'}>
                        <div className="rating-star-container">
                            <div className="feedback-star-title">
                                <b>
                                    <FormattedMessage id="overall"
                                    defaultMessage="Overall:"
                                /></b>
                            </div>
                            <div className="feedback-star-container" style={config.lang=='ar' ? {direction:'ltr'}:{}}>
                                <ReactStars value={overall_rating} count={5} size={30} color2={'#ffd700'} onChange={(e)=>this.ratingChanged(e,"overall_rating")} />
                            </div>
                        </div>
                        <div className="rating-star-container">
                            <div className="feedback-star-title">
                                <b>
                                            <FormattedMessage id="content"
                                                defaultMessage="Content:"
                                            />
                                </b>
                            </div>
                            <div className="feedback-star-container" style={config.lang=='ar' ? {direction:'ltr'}:{}}>
                                <ReactStars value={content_rating} count={5} size={30} color2={'#ffd700'}  onChange={(e)=>this.ratingChanged(e,"content_rating")} />
                            </div>
                        </div>
                        <div className="rating-star-container">
                            <div className="feedback-star-title">
                                <b>
                                            <FormattedMessage id="easyTo"
                                                defaultMessage="Easy to navigate:"
                                            />
                                </b>
                            </div>
                            <div className="feedback-star-container" style={config.lang=='ar' ? {direction:'ltr'}:{}}>
                                <ReactStars value={etn_rating} count={5} size={30} color2={'#ffd700'} onChange={(e)=>this.ratingChanged(e,"etn_rating")} />
                            </div>
                        </div>
                        <div className="rating-star-container">
                            <div className="feedback-star-title">
                                <b>
                                            <FormattedMessage id="site"
                                                defaultMessage="Site reliability:"
                                            />
                                </b>
                            </div>
                            <div className="feedback-star-container" style={config.lang=='ar' ? {direction:'ltr'}:{}}>
                                <ReactStars value={reliability_rating} count={5} size={30} color2={'#ffd700'} onChange={(e)=>this.ratingChanged(e,"reliability_rating")} />
                            </div>
                        </div>
                    </div>
                    <div className="comment-container">
                        <b>
                                    <FormattedMessage id="yourComments"
                                        defaultMessage="Your Comments:"
                                    />
                        </b>
                                <textarea placeholder={commentPlaceholder} onChange={this.handleComment} value={comment} name="text" id="exampleText" className={"comment-textarea"} />
                        <Button style={{width:"100%",backgroundColor:"#cc1e97",marginTop:'2%',color:"white"}} onClick={this.handleAddFeedbackData}>
                                    <FormattedMessage id="submit"
                                        defaultMessage="Submit"
                                    />
                        </Button>
                    </div>
                </div>}
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
   
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);


// WEBPACK FOOTER //
// ./src/components/feedback/feedback.js